(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-new-products"] && !window.DesignMode) return;
  try {
    

$('.slick-carousel').slick({
  centerPadding: '40px',
  infinite: true,
  slidesToShow: 4, // Shows a three slides at a time
  slidesToScroll: 3, // When you click an arrow, it scrolls 1 slide at a time
  arrows: false, // Adds arrows to sides of slider
  dots: true, // Adds the dots on the bottom
  autoplay: true,
  responsive: [
    {
      breakpoint: 768, // Mobile breakpoint screen
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

const header = document.querySelector('.autohide');
const color = document.querySelector('.color')

window.onscroll = function () {

  let top = window.scrollY;
  console.log(top)
  if (top >= 10) {
    color.classList.add('color-two')
    header.classList.remove('active-2')
    header.classList.remove('scrolled-upp')
  } else {
    color.classList.remove('color-two')
    header.classList.add('active-2')
    header.classList.add('scrolled-upp')
  }
}

var bounce = $('.color');
bounce.addClass('duration');
$(window).scroll(function () {
  if ($(window).scrollTop() >= 80) {
    bounce.removeClass('color');
    bounce.addClass('color-two');
  } else {
    if (bounce.hasClass('color-two')) {
      bounce.removeClass('color-two');
      bounce.addClass('color');
    }
  }
});;

var bounce = $('.autohide-two');
bounce.addClass('duration');
$(window).scroll(function () {
  if ($(window).scrollTop() >= 80) {
    bounce.removeClass('active-2');
    bounce.addClass('active');
  } else {
    if (bounce.hasClass('active')) {
      bounce.removeClass('active');
      bounce.addClass('active-2');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {

  el_autohide = document.querySelector('.autohide');

  if (el_autohide) {
    var last_scroll_top = 0;
    window.addEventListener('scroll', function () {
      let scroll_top = window.scrollY;

      if (scroll_top < last_scroll_top) {
        el_autohide.classList.remove('scrolled-down');
        el_autohide.classList.add('scrolled-up');
        el_autohide.classList.add('active');
      } else {
        el_autohide.classList.remove('scrolled-up');
        el_autohide.classList.add('scrolled-down');
        el_autohide.classList.remove('active');
      }
      last_scroll_top = scroll_top;
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-collection"] && !window.DesignMode) return;
  try {
    

$('.slick-carousle-collection').slick({
  centerPadding: '40px',
  infinite: true,
  slidesToShow: 4, // Shows a three slides at a time
  slidesToScroll: 3, // When you click an arrow, it scrolls 1 slide at a time
  arrows: false, // Adds arrows to sides of slider
  dots: true, // Adds the dots on the bottom
  autoplay: true,
  responsive: [
    {
      breakpoint: 768, // Mobile breakpoint screen
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-new-products"] && !window.DesignMode) return;
  try {
    

$('.slick-carousel').slick({
	centerPadding: '40px',
	infinite: true,
	slidesToShow: 4, // Shows a three slides at a time
	slidesToScroll: 3, // When you click an arrow, it scrolls 1 slide at a time
	arrows: false, // Adds arrows to sides of slider
	dots: true ,// Adds the dots on the bottom
	autoplay: true,
	responsive: [
		{
			breakpoint: 768, // Mobile breakpoint screen
			settings: {
				arrows: false,
				centerMode: true,
				centerPadding: '40px',
				slidesToShow: 1
			}
		}
	]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-quiz"] && !window.DesignMode) return;
  try {
    

(function (w, d, s, o) {
  var j = d.createElement(s);
  j.async = true;
  j.src = '//script.marquiz.io/v2.js';
  j.onload = function () {
    if (document.readyState !== 'loading')
      Marquiz.init(o);
     else
      document.addEventListener("DOMContentLoaded", function () {
        Marquiz.init(o);
      });

  };
  d.head.insertBefore(j, d.head.firstElementChild);
})(window, document, 'script', {
  host: '//quiz.marquiz.io',
  region: 'us',
  id: '60e310aed24be100262d8a2e',
  autoOpen: false,
  autoOpenFreq: 'once',
  openOnExit: false,
  disableOnMobile: false
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-video"] && !window.DesignMode) return;
  try {
    

$('.slider-single').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  adaptiveHeight: true,
  infinite: false,
  useTransform: true,
  speed: 400,
  cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
});

$('.slider-nav').on('init', function (event, slick) {
  $('.slider-nav .slick-slide.slick-current').addClass('is-active');
}).slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  dots: false,
  focusOnSelect: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    }, {
      breakpoint: 640,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 420,
      settings: {
        slidesToShow: 2
      }
    }
  ]
});

$('.slider-single').on('afterChange', function (event, slick, currentSlide) {
  $('.slider-nav').slick('slickGoTo', currentSlide);
  var currrentNavSlideElem = '.slider-nav .slick-slide[data-slick-index="' + currentSlide + '"]';
  $('.slider-nav .slick-slide.is-active').removeClass('is-active');
  $(currrentNavSlideElem).addClass('is-active');
});

$('.slider-nav').on('click', '.slick-slide', function (event) {
  event.preventDefault();
  var goToSingleSlide = $(this).data('slick-index');

  $('.slider-single').slick('slickGoTo', goToSingleSlide);
});


  } catch(e) { console.error(e); }
})();

})();
